<script setup lang="ts">
    const appStore = useAppStore();
    const { socialLinks } = storeToRefs(appStore);
</script>

<template>
    <div class="atm-social-links flex flex-wrap gap-3 md:gap-5">
        <template
            v-for="network in socialLinks"
            :key="network.key">
            <nuxt-link
                :to="network.url"
                class="transition-colors hover:text-woom-red"
                target="_blank"
                :aria-label="$t('cta.network', { network: network.key })">
                <component
                    :is="network.icon"
                    class="h-9 w-9 fill-current md:h-10 md:w-10" />
            </nuxt-link>
        </template>
    </div>
</template>
